import { render, staticRenderFns } from "./FAQsView.vue?vue&type=template&id=282b2aff&scoped=true&"
import script from "./FAQsView.vue?vue&type=script&lang=js&"
export * from "./FAQsView.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/faq.css?vue&type=style&index=0&id=282b2aff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b2aff",
  null
  
)

export default component.exports